import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
    selector: 'mg-file-input',
    templateUrl: './file-input.component.html',
    styleUrls: ['./file-input.component.scss'],
})
export class FileInputComponent {
    currentFileName: string

    @Input() control: FormControl

    constructor() {}

    onFileChange(event) {
        /*
      Once a file is inputted, we convert it to Base64 (the type expected by 
      our API) using the readAsDataURL method of the FileReader web API:
      https://developer.mozilla.org/en-US/docs/Web/API/FileReader
    */

        if (event.target.files.length) {
            const reader = new FileReader()
            const [file]: [File] = event.target.files

            this.currentFileName = file.name

            reader.readAsDataURL(file)

            reader.onload = () => {
                this.control.setValue(reader.result)
            }
        }
    }
}
